import { FC } from 'react';

import HelpCenter from '@/components/HelpCenter/HelpCenter';

const HelpCenterPage: FC = () => <HelpCenter />;

export function getStaticProps() {
  return {
    props: {},
  };
}

export default HelpCenterPage;
